import { z } from 'zod';

export const warrantyReasonSchema = z.enum([
  'not_powering_on',
  'sensor_malfunction',
  'connectivity_issue',
  'physical_damage',
  'other',
]);

export const warrantyClaimStatusSchema = z.enum([
  'submitted',
  'under_review',
  'info_requested',
  'approved',
  'rejected',
  'closed',
]);

export const rejectionReasonSchema = z.enum([
  'out_of_warranty',
  'damage_not_covered',
  'customer_fault',
  'insufficient_evidence',
  'other',
]);

const claimActorSchema = z.enum(['grower', 'admin', 'system']);

/** Listing row — the shape returned by the list endpoint and after creation. */
export const warrantyClaimSchema = z.object({
  id: z.string(),
  ref: z.string(),
  deviceId: z.string(),
  deviceName: z.string(),
  serial: z.string(),
  imageUrl: z.string(),
  reason: warrantyReasonSchema,
  reasonOther: z.string().nullable(),
  description: z.string(),
  status: warrantyClaimStatusSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
  unread: z.boolean(),
  responseRequired: z.boolean(),
});

export const claimTimelineEventSchema = z.object({
  id: z.string(),
  status: warrantyClaimStatusSchema,
  label: z.string(),
  timestamp: z.string(),
  state: z.enum(['done', 'current']),
});

export const claimCommentSchema = z.object({
  id: z.string(),
  actor: claimActorSchema,
  authorName: z.string(),
  body: z.string(),
  images: z.array(z.string()),
  timestamp: z.string(),
});

export const claimShipmentSchema = z.object({
  trackingNumber: z.string(),
  carrier: z.string(),
  expectedDeliveryAt: z.string(),
});

export const warrantyClaimDetailSchema = warrantyClaimSchema.extend({
  orderId: z.string(),
  images: z.array(z.string()),
  rejectionReason: rejectionReasonSchema.nullable(),
  timeline: z.array(claimTimelineEventSchema),
  comments: z.array(claimCommentSchema),
  shipment: claimShipmentSchema.nullable(),
});

export const warrantyEligibilitySchema = z.object({
  status: z.enum(['eligible', 'expired', 'open_claim']),
  expiresAt: z.string().nullable(),
});
